<ng-template #vrSearchTooltip>
  <p>
    {{ 'Trains, locomotives, equipment, traffic control points, stations and addresses' | translate}}
  </p>
</ng-template>

<div class="toolbar d-flex justify-content-between flex-row">
  <div class="toolbar-block d-flex align-items-center">
    <img class="logo" *ngFor="let logo of logoArr" [src]="logo" style="height: 22px;">
    <div style="margin-left: 0.7em;">
      <ng-container [ngSwitch]="tenant">
        <qm-search *ngSwitchCase="2" [searchTooltipAdditionalText]="vrSearchTooltip"></qm-search>
        <qm-search *ngSwitchDefault></qm-search>
      </ng-container>

    </div>
    <div class="btn-group">

      <div class="toolbar-btn" *ngIf="injectedComponent">
        <ng-container *ngComponentOutlet="injectedComponent"></ng-container>
      </div>
    </div>
  </div>
  <div class="toolbar-block d-flex flex-row align-items-center" *qmAuth="'clock'">
    <div class="date">
      <span>{{clock | qmDateFormat: 'EEE dd MMM'}}</span>
    </div>

    <div class="clock">
      <span>{{clock | qmDateFormat: 'HH:mm:ss'}}</span>
    </div>
  </div>
  <div class="right-block toolbar-block">
    <!-- FIXME: tenant if -->
    <qm-neve-measurements-toolbar *ngIf="tenant === 14"></qm-neve-measurements-toolbar>
    <div *ngIf="showVivoLink">
      <a
        class="custom-button"
        href="https://miprovivo.trackinno.com"
        target="_blank"
        ngbTooltip="{{ 'Open Mipro VIVO in a new tab' | translate }}"
      >VIVO</a>
    </div>
    <div class="forecast" *ngIf="weather && weather.main">
      <i class="wi fa-2x" [ngClass]="getIconClass()"></i>
      <div class="d-flex align-items-baseline">
        <span class="temperature">{{weather.main.temp}}</span> <i class="wi fa-2x wi-celsius"></i>
      </div>
    </div>
    <div class="settings mr-0">
      <button type="button" class="custom-button" (click)="openVerticallyCentered(licenses)" ngbTooltip="{{ 'Licenses' | translate }}">
        <i class="fal fa-copyright"></i>
      </button>
    </div>
    <div class="settings ml-0" *ngIf="helpDoc">
      <button type="button" class="custom-button" (click)="openVerticallyCentered(help)" ngbTooltip="{{ 'Help' | translate }}">
        <i class="fal fa-question-circle"></i>
      </button>
    </div>
    <div class="monitors">
      <qm-monitors></qm-monitors>
    </div>
    <div class="settings">
      <qm-user-settings></qm-user-settings>
    </div>
  </div>
</div>

<ng-template #help let-modal>
  <div style="height: 60vh; width:1000px;">
    <embed [src]="helpDoc" type="application/pdf" height="100%" width="100%">
  </div>
</ng-template>

<ng-template #licenses let-modal>
  <div class="card">
    <div class="card-body">
      <div class="license-text">
        <button type="button" class="custom-button close-button" (click)="closeModal()">
          <i class="fal fa-window-close"></i>
        </button>
        <h4 class="card-title">{{'Licenses' | translate}}</h4>
        <p class="card-text">{{'Open Source Licenses used in the application.' | translate}}</p>
      </div>
      <div class="license-links">
        <div class="list-group">
          <a target="_blank" href="https://rata.digitraffic.fi" rel="noopener noreferrer">
            Liikennevirasto
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
